<template>
  <div class="table-tab-list d-flex" :style="containerStyle">
    <!-- tabs -->
    <div v-for="table_tab in tableData.tableSelectList" :key="table_tab.value"
      @click="handleTabClick(table_tab)"
      class="d-flex align-center justify-center"
      :class="`table-tab-${table_tab.value}`"
      style="height: 100%; cursor: pointer"
    >
      <!-- tab wrapper -->
      <div class="tab-wrapper d-flex align-center justify-center"
        style="height: 100%; padding: 3px; border-radius: 0px 0px 8px 8px; border-width: 0px 1px 1px 1px; border-style: solid"
        :style="isTabActive(table_tab) ?
          'background-color: #ffffff; border-color: #E8EAF2; box-shadow: 4px -2px 6px 0px #0D0E170F' :
          'background-color: transparent; border-color: transparent'
        "
      >
        <!-- inner box -->
        <div class="d-flex align-center justify-center"
          :class="isTabActive(table_tab) ? '' : 'hover-bg-color'"
          style="--hover-bg-color: #E8EAF2; width: 100%; height: 100%; border-radius: 8px"
          :style="[
            {backgroundColor: table_tab.value === modifyingNameTableIdx ? '#E8EAF2' : ''}
          ]"
        >
          <!-- content -->
          <div class="d-flex align-center justify-center"
            style="width: 100%; height: 100%; gap: 4px"
            :style="
              table_tab.value === modifyingNameTableIdx ? '' : 
              showMenuBtn ? 'padding: 0px 0px 0px 14px' : 
              isTabActive(table_tab) ? 'padding: 0px 14px' : 'padding: 0px 14px'
            "
          >
            <!-- text (default) -->
            <div v-if="table_tab.value !== modifyingNameTableIdx" v-ellipsis-tooltip
              style="font-size: 14px; line-height: 16px; max-width: 100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
              :style="
                isTabActive(table_tab) ? 
                'font-weight: 600; color: #687EFF' : 
                'font-weight: 500; color: #414458'
              "
            >
              {{ table_tab.text }}
            </div>
            <!-- menu btn -->
            <v-menu v-if="showMenuBtn && table_tab.value !== modifyingNameTableIdx" offset-y top right>
              <template v-slot:activator="{ on, value }">
                <div v-on="on"
                  class="hover-bg-color d-flex align-center justify-center"
                  style="--hover-bg-color: #D8DAE9; min-width: 24px; height: 24px; border-radius: 50%"
                >
                  <v-icon :class="value ? 'up' : 'down'" style="font-size: 16px; color: #8A8DA8">
                    mdi-chevron-down
                  </v-icon>
                </div>
              </template>
              <v-card style="width: 170px">
                <!-- 시트 이름 변경 -->
                <div @click="clickModifyTableNameBtn(table_tab)"
                  class="hover-bg-color-EFF0F6 d-flex align-center"
                  style="width: 100%; height: 40px; padding: 0px 12px; gap: 8px; cursor: pointer"
                >
                  <v-icon style="font-size: 20px; color: #414458">
                    mdi-rename-outline
                  </v-icon>
                  <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                    시트 이름 변경
                  </div>
                </div>
                <!-- 시트 삭제 -->
                <!-- <div 
                  class="hover-bg-color-EFF0F6 d-flex align-center"
                  style="width: 100%; height: 40px; padding: 0px 12px; gap: 8px; cursor: pointer"
                >
                  <v-icon style="font-size: 20px; color: #414458">
                    mdi-trash-can-outline
                  </v-icon>
                  <div style="font-size: 14px; font-weight: 500; line-height: 18px; color: #414458">
                    시트 삭제
                  </div>
                </div> -->
              </v-card>
            </v-menu>
            <!-- text (editing) -->
            <div v-if="table_tab.value === modifyingNameTableIdx"
              v-click-outside="clickOutsideModifyingTableNameInput"
              class="d-flex align-center"
              style="padding: 0px 14px"
            >
              <input v-model="table_tab.text" type="text" placeholder=""
                @keyup.enter="modifyTableName(table_tab)" @keyup.esc="cancelModifyTableName(table_tab)"
                class="input-area sheet-name-input" style="width: 100%; height: 100%; font-size: 14px; font-weight: 400; line-height: 18px; color: #414458"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableTabList',
  props: {
    tableData: {
      type: Object,
      required: true,
    },
    modifyingNameTableIdx: {
      type: Number,
      default: null,
    },
    containerStyle: {
      type: String,
      default: 'flex: 1; height: 100%; overflow: auto hidden',
    },
    showMenuBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isTabActive(table_tab) {
      return this.tableData.currTableIdx === table_tab.value
    },
    handleTabClick(table_tab) {
      if (!this.isTabActive(table_tab)) {
        this.$emit('click-tab', table_tab)
      }
    },
    clickModifyTableNameBtn(table_tab) {
      this.$emit('clickModifyTableNameBtn', table_tab)
    },
    modifyTableName(table_tab) {
      this.$emit('modifyTableName', table_tab)
    },
    cancelModifyTableName(table_tab) {
      this.$emit('cancelModifyTableName', table_tab)
    },
    clickOutsideModifyingTableNameInput() {
      this.$emit('clickOutsideModifyingTableNameInput')
    },
  },
}
</script>
